import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-tool-box',
  standalone: true,
  imports: [],
  templateUrl: './tool-box.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tool-box.component.scss'
})
export class ToolBoxComponent {

}
